/**
 * 后台 TanStack Query 配置：4xx 不重试，网络错误与 5xx 最多重试 2 次；写操作不自动重试；
 * 断网时保留最近一次数据（后台离线提示"网络已断开，数据更新于 {time}"，写按钮置灰由页面根据 useAdminShell().online 决定）。
 */
import { QueryClient } from '@tanstack/react-query';
import { shouldRetryRequest } from '@nexora/ui';

export const ADMIN_QUERY_STALE_MS = 30_000;

export function createAdminQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: shouldRetryRequest, staleTime: ADMIN_QUERY_STALE_MS, refetchOnWindowFocus: true, refetchOnReconnect: true },
      mutations: { retry: false },
    },
  });
}
